@switch (state$$()) {
    @case ('confirming') {
        <div class="header">Bezig met bevestigen…</div>
        <div>Een moment geduld, je e-mailadres wordt bevestigd.</div>
    }
    @case ('confirmed') {
        <div class="header">Je e-mailadres is bevestigd!</div>
        <div>Je kunt nu inloggen met je account.</div>
        <button mat-flat-button color="primary" routerLink="/login">Naar login</button>
    }
    @case ('failed') {
        <div class="header">Bevestigen mislukt</div>
        <div>De bevestigingslink is ongeldig of verlopen. Vraag op de loginpagina een nieuwe bevestigingsmail aan of registreer opnieuw.</div>
        <button mat-flat-button color="primary" routerLink="/login">Naar login</button>
    }
    @case ('missingParams') {
        <div class="header">Ongeldige link</div>
        <div>Deze bevestigingslink is niet compleet. Gebruik de link uit de e-mail die je hebt ontvangen.</div>
        <button mat-flat-button color="primary" routerLink="/login">Naar login</button>
    }
}
